<script lang="ts">
	import type { Branch, OutletBranch } from "../../../core/schema/Branch";
	import type { WebPlannedIceCreams } from "../../../core/schema/PlannedIceCream";
	import { getIceCreamName } from "../../../core/utils/getIceCreamName";
	import { nbspify } from "../../../core/utils/nbspify";
	import { getGlobalSettings } from "../getGlobalSettings";
	import DynamicPicture from "./Picture/DynamicPicture.svelte";
	import { DateTime } from "../../../core/utils/luxon";
	import { isoDateFormat } from "../../../core/utils/isoDateFormat";

	export let plannedIceCreams: WebPlannedIceCreams;
	export let branch: Branch;

	const { TENANT_LOCALE } = getGlobalSettings();

	const closingHour = 18;

	$: iceCreamIsForToday =
		DateTime.fromFormat(plannedIceCreams.date, isoDateFormat).toISODate() === DateTime.now().toISODate() &&
		DateTime.now().hour < closingHour;
	$: dataByDay = iceCreamIsForToday ? plannedIceCreams.today : plannedIceCreams.tomorrow;
	$: dataByBranch = dataByDay[branch as OutletBranch];
	$: iceCream = dataByBranch?.iceCream;
</script>

<div class="mt-5 flex justify-center gap-3 sm:grid sm:grid-cols-2">
	{#if iceCream !== undefined}
		{@const { flavour1, flavour2, image } = iceCream}
		<div class="flex flex-col justify-between">
			<div>
				<p class="text-xs sm:text-sm sm:font-semibold">
					{nbspify(iceCreamIsForToday ? "Dnešní točená zmrzlina:" : "Zítřejší točená zmrzlina:")}
				</p>
				<ul class="mt-4 sm:mt-7">
					<li class="text-md font-semibold sm:text-lg">{nbspify(flavour1[TENANT_LOCALE])}</li>
					<li class="text-md font-semibold sm:text-lg">{nbspify(flavour2[TENANT_LOCALE])}</li>
				</ul>
			</div>
			<div>
				<p class="mb-4 mt-4 text-xs sm:mb-0">{nbspify("Zmrzlinu máme do vyprodání")}</p>
			</div>
		</div>
		{#if image}
			<div class="rounded-lg">
				<DynamicPicture
					imgClass="rounded-md object-cover md:h-64 lg:h-80 xl:h-[344px]"
					{image}
					width={248}
					height={344}
					alt="Točená zmrzlina – {getIceCreamName(iceCream, TENANT_LOCALE)}"
					bucket="storage"
					loading="lazy"
				/>
			</div>
		{/if}
	{:else}
		<div class="text-md col-span-2 text-center font-semibold leading-8 sm:text-left lg:text-lg">
			{nbspify("Dnes točená zmrzlina není!")}
		</div>
	{/if}
</div>
